import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  questionTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: theme.palette.primary.main,
    lineHeight: 1.5,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  alternativeItem: {
    marginBottom: 4,
    borderRadius: 4,
    border: `1px solid ${colors.grey[200]}`,
    backgroundColor: theme.palette.common.white,
  },
  alternativeItemSelected: {
    backgroundColor: theme.palette.primary.light,
    borderColor: theme.palette.primary.main,
  },
  alternativeLabel: {
    margin: 0,
    padding: theme.spacing(0.75, 1),
    width: '100%',
  },
  alternativeText: {
    fontSize: 13,
    color: theme.palette.text.primary,
  },
  answerChip: {
    backgroundColor: colors.green[100],
    color: colors.green[800],
    fontWeight: 500,
  },
}))

export default styles
